import { CompanySuggestion } from '@savgroup-front-common/types/CompanyDirectory';

const COMPANY_SEARCH_DETAILS_SEPARATOR = ' · ';

export const formatCompanySearchDetails = (
  company: CompanySuggestion,
): string =>
  [company.registrationNumber, company.address?.city]
    .filter((detail) => !!detail)
    .join(COMPANY_SEARCH_DETAILS_SEPARATOR);
